// Domain module extracted from lib/api.ts (frontend containment F1).
// Moved verbatim: endpoint paths, methods, payloads, parsing, types and export names
// are unchanged. Import via lib/api.ts, which re-exports this module.
import { request } from './client';

// ── Strafe (bulk prospecting) ─────────────────────────────────────────

export interface StrafeEmail {
  step: number;
  subject: string;
  body: string;
  recommended_attachments: string[];
  delay_days: number;
}

export interface StrafePreviewSample {
  contact_email: string;
  contact_name: string;
  client: string;
  engagement: 'never_contacted' | 'engaged' | 'stale';
  emails: StrafeEmail[];
}

export interface StrafePreviewResponse {
  job_id: string;
  samples: StrafePreviewSample[];
  total_planned: number;
}

export interface StrafeJob {
  id: string;
  status: 'preview' | 'queued' | 'running' | 'done' | 'failed' | 'discarded';
  strategy: string;
  persona?: string;
  num_emails?: number;
  initial_offset_minutes?: number;
  delay_2_days?: number;
  delay_3_days?: number;
  thread_chain?: boolean;
  dispatch_stagger_seconds?: number;
  use_conversion_examples?: boolean;
  total: number;
  completed: number;
  failed: number;
  created_at: string;
  finished_at?: string;
}

export interface StrafeTarget {
  contact_email: string;
  contact_name: string;
  client: string;
  is_sample: boolean;
  status: 'pending' | 'generating' | 'previewed' | 'scheduled' | 'failed';
  sequence_id: string;
  error?: string;
  emails?: StrafeEmail[];  // populated for previewed targets
  engagement?: 'never_contacted' | 'engaged' | 'stale';
}

export const strafePreview = (data: {
  contact_emails: string[];
  sample_emails?: string[];
  strategy: string;
  persona?: string;
  voice?: string;
  num_emails: number;
  initial_offset_minutes: number;
  delay_2_days: number;
  delay_3_days: number;
  thread_chain?: boolean;
  dispatch_stagger_seconds?: number;
  use_conversion_examples?: boolean;
}) =>
  request<StrafePreviewResponse>('/prospecting/strafe/preview', {
    method: 'POST', body: JSON.stringify(data),
  });

export const strafeCommit = (job_id: string, all_target_emails: string[]) =>
  request<{ job_id: string; scheduled_now: number; queued: number; total: number }>(
    `/prospecting/strafe/${job_id}/commit`,
    { method: 'POST', body: JSON.stringify({ all_target_emails }) },
  );

export const strafeDiscard = (job_id: string) =>
  request<{ ok: boolean }>(`/prospecting/strafe/${job_id}`, { method: 'DELETE' });

export const getStrafeJob = (job_id: string) =>
  request<{ job: StrafeJob; targets: StrafeTarget[] }>(`/prospecting/strafe/${job_id}`);

export const listStrafes = () =>
  request<StrafeJob[]>('/prospecting/strafe');

// Bulk unschedule
export const bulkUnschedule = (filter: {
  ids?: string[];
  sequence_ids?: string[];
  strafe_job_id?: string;
  client?: string;
  before?: string;
  after?: string;
}) =>
  request<{ cancelled: number }>('/email/scheduled/bulk', {
    method: 'DELETE', body: JSON.stringify(filter),
  });
